/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChangeRequestHourRangeRequest } from './ChangeRequestHourRangeRequest';
import {
    ChangeRequestHourRangeRequestFromJSON,
    ChangeRequestHourRangeRequestFromJSONTyped,
    ChangeRequestHourRangeRequestToJSON,
    ChangeRequestHourRangeRequestToJSONTyped,
} from './ChangeRequestHourRangeRequest';

/**
 * 
 * @export
 * @interface ChangeRequestOpeningDay
 */
export interface ChangeRequestOpeningDay {
    /**
     * 
     * @type {Array<ChangeRequestHourRangeRequest>}
     * @memberof ChangeRequestOpeningDay
     */
    hours?: Array<ChangeRequestHourRangeRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof ChangeRequestOpeningDay
     */
    isOpen?: boolean;
}

/**
 * Check if a given object implements the ChangeRequestOpeningDay interface.
 */
export function instanceOfChangeRequestOpeningDay(value: object): value is ChangeRequestOpeningDay {
    return true;
}

export function ChangeRequestOpeningDayFromJSON(json: any): ChangeRequestOpeningDay {
    return ChangeRequestOpeningDayFromJSONTyped(json, false);
}

export function ChangeRequestOpeningDayFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChangeRequestOpeningDay {
    if (json == null) {
        return json;
    }
    return {
        
        'hours': json['hours'] == null ? undefined : ((json['hours'] as Array<any>).map(ChangeRequestHourRangeRequestFromJSON)),
        'isOpen': json['isOpen'] == null ? undefined : json['isOpen'],
    };
}

export function ChangeRequestOpeningDayToJSON(json: any): ChangeRequestOpeningDay {
    return ChangeRequestOpeningDayToJSONTyped(json, false);
}

export function ChangeRequestOpeningDayToJSONTyped(value?: ChangeRequestOpeningDay | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hours': value['hours'] == null ? undefined : ((value['hours'] as Array<any>).map(ChangeRequestHourRangeRequestToJSON)),
        'isOpen': value['isOpen'],
    };
}

